import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LANGUAGE } from "@prequalification/models";
import { ProductService } from "@prequalification/services";
import { take } from "rxjs";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "prequalification-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
export class AppComponent implements OnInit {
  lob = this.productService.chnl === "CCPA" ? "credit cards" : "bfs";

  constructor(
    private translateService: TranslateService,
    private productService: ProductService,
    private titleService: Title
  ) {
    this.loadScript();
  }
  ngOnInit(): void {
    this.saveLangPref();
  }

  setPageTitle() {
    this.translateService
      .get("GLOBAL.TAB_NAME")
      .pipe(take(1))
      .subscribe((pageTitle: string) => {
        this.titleService.setTitle(pageTitle);
      });
  }

  saveLangPref() {
    if (this.productService.lang === LANGUAGE.FR) {
      this.translateService.setDefaultLang(this.productService.lang);
    } else if (this.productService.lang === LANGUAGE.EN) {
      this.translateService.setDefaultLang(this.productService.lang);
    } else {
      this.translateService.setDefaultLang(this.productService.lang);
    }
    this.translateService.use(this.productService.lang);
    this.setPageTitle();
  }

  // dynamically append GA script and switch between CCPA / bfs LOB.
  loadScript() {
    // document call only runs on the browser, need to check otherwise would be undefined
    if (typeof document !== "undefined") {
      const node = document.createElement("script");
      node.innerHTML = `window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ LOB: '${this.lob}' });
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-K5TWTL');`;
      node.type = "text/javascript"; // Set the script type
      node.async = true;
      node.charset = "utf-8";
      // Append to head of document
      document.getElementsByTagName("head")[0].appendChild(node);
    }
  }
}
